import { getContext, setContext } from "svelte";
import { writable, type Writable } from "svelte/store";
import { StoreKeys } from "./StoresKeys";
import type { Product } from "$lib/server/database/drizzle-schemas";

const configuratorProductsStore = writable<Array<Product>>([]);

export const useConfiguratorProductsStore = (initialValues?: Array<Product>) => {
	if (initialValues) {
		configuratorProductsStore.set(initialValues);
	}

	const setConfiguratorProducts = () => {
		setContext(StoreKeys.CONFIGURATOR_PRODUCTS, configuratorProductsStore);
	};

	return {
		setConfiguratorProducts,
		...configuratorProductsStore
	};
};

export const getConfiguratorProductsStore = (): Writable<Array<Product>> => {
	return getContext(StoreKeys.CONFIGURATOR_PRODUCTS);
};
